import {ReactComponent as CandleIcon} from "../../icons/candle.svg";
import {ReactComponent as HeartIcon} from "../../icons/heart.svg";
import {ReactComponent as CommentIcon} from "../../icons/comment.svg";
import styled from 'styled-components';

const Stat = styled.div`
    height: 30px;
    width: 40px;
    position: relative;
`;

const Count = styled.span.attrs({
    className: 'count cr-bg-alert cr-rounded-full cr-flex cr-center cr-text-xs cr-text-white',
})`
    bottom: 0;
    height: 2em;
    position: absolute;
    right: 0;
    width: 2em;
    z-index: 1;
`

type TProps = {
    numberOfCandles: number;
    numberOfPosts: number;
    numberOfLikes: number;
}

const Stats = ({numberOfCandles, numberOfPosts, numberOfLikes}: TProps) => {
    const hasCandles = (numberOfCandles > 0);
    const hasPosts = (numberOfPosts > 0);
    const hasLikes = (numberOfLikes > 0);
    const hasStats = hasCandles || hasPosts || hasLikes;

    return hasStats ? (
        <div className="cr-flex cr-gap-lg cr-text-secondary">
            {hasCandles &&
                <Stat>
                    <CandleIcon/>
                    <Count>{numberOfCandles}</Count>
                </Stat>
            }
            {hasLikes &&
                <Stat>
                    <HeartIcon/>
                    <Count>{numberOfLikes}</Count>
                </Stat>
            }
            {hasPosts &&
                <Stat>
                    <CommentIcon/>
                    <Count>{numberOfPosts}</Count>
                </Stat>
            }
        </div>
    ) : null;
}

export default Stats;
